import React from "react";

import { Label, Input, RadioGroup, FieldWrapper } from "./styles";

import { states } from "./form-data";

export default function ContactInformation({ errors, touched, values }) {
    return (
        <>
            <FieldWrapper width={50}>
                <Label htmlFor="firstName">
                    First Name*
                    <Input
                        type="text"
                        name="firstName"
                        autoCorrect="off"
                        autoComplete="given-name"
                        valid={touched.firstName && !errors.firstName}
                        error={touched.firstName && errors.firstName}
                    />
                </Label>
            </FieldWrapper>

            <FieldWrapper width={50}>
                <Label htmlFor="lastName">
                    Last Name*
                    <Input
                        type="text"
                        name="lastName"
                        autoCorrect="off"
                        autoComplete="family-name"
                        valid={touched.lastName && !errors.lastName}
                        error={touched.lastName && errors.lastName}
                    />
                </Label>
            </FieldWrapper>

            <FieldWrapper width={100}>
                <Label htmlFor="address">
                    Street Address{errors.address && `*`}
                    <Input
                        type="text"
                        name="address"
                        autoCorrect="off"
                        autoComplete="street-address"
                        valid={touched.address && !errors.address}
                        error={touched.address && errors.address}
                    />
                </Label>
            </FieldWrapper>

            <FieldWrapper width={40}>
                <Label htmlFor="city" width={40}>
                    City
                    <Input
                        type="text"
                        name="city"
                        autoCorrect="off"
                        autoComplete="address-level2"
                        valid={touched.city && !errors.city}
                        error={touched.city && errors.city}
                    />
                </Label>
            </FieldWrapper>

            <FieldWrapper width={32}>
                <Label htmlFor="state">
                    State
                    <Input
                        inputType="select"
                        name="state"
                        autoCorrect="off"
                        autoComplete="address-level1"
                        valid={touched.state && !errors.state}
                        error={touched.state && errors.state}
                    >
                        <option value="" />
                        {states.map((el) => {
                            return (
                                <option
                                    key={el.abbreviation}
                                    value={el.abbreviation}
                                    aria-label={el.name}
                                >
                                    {el.abbreviation} - {el.name}
                                </option>
                            );
                        })}
                    </Input>
                </Label>
            </FieldWrapper>

            <FieldWrapper width={28}>
                <Label htmlFor="zip">
                    Zip*
                    <Input
                        type="text"
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                            );
                            e.target.value = e.target.value.slice(0, 5);
                        }}
                        name="zip"
                        autoCorrect="off"
                        autoComplete="postal-code"
                        valid={touched.zip && !errors.zip}
                        error={touched.zip && errors.zip}
                    />
                </Label>
            </FieldWrapper>

            <FieldWrapper width={40}>
                <Label htmlFor="phone">
                    Phone
                    <Input
                        //Need to use text type in order to have dashes
                        type="text"
                        //Restrict input
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(
                                /[^0-9-]/g,
                                ""
                            );

                            //Limit the input length
                            let val = e.target.value.slice(0, 12);

                            if (e.target.value.length === 3) {
                                val = val + "-";
                            }
                            if (e.target.value.length === 7) {
                                val = val + "-";
                            }

                            e.target.value = val;
                        }}
                        name="phone"
                        autoCorrect="off"
                        autoComplete="tel"
                        valid={touched.phone && !errors.phone}
                        error={touched.phone && errors.phone}
                    />
                </Label>
            </FieldWrapper>

            <FieldWrapper width={60}>
                <Label htmlFor="email">
                    Email*
                    <Input
                        type="email"
                        name="email"
                        autoCapitalize="off"
                        autoCorrect="off"
                        autoComplete="email"
                        valid={touched.email && !errors.email}
                        error={touched.email && errors.email}
                    />
                </Label>
            </FieldWrapper>

            {values.phone.length > 0 && (
                <Label id="textOptIn">
                    Okay to text me at this number?*
                    <RadioGroup
                        inline
                        role="group"
                        aria-labelledby="textOptIn"
                        name="textOptIn"
                        valid={touched.textOptIn && !errors.textOptIn}
                        error={touched.textOptIn && errors.textOptIn}
                    >
                        <Label>
                            Yes
                            <Input type="radio" name="textOptIn" value="Yes" />
                        </Label>
                        <Label>
                            No
                            <Input type="radio" name="textOptIn" value="No" />
                        </Label>
                    </RadioGroup>
                </Label>
            )}
        </>
    );
}
